import { render, staticRenderFns } from "./TicketCreation.vue?vue&type=template&id=60c4a3c9&scoped=true"
import script from "./TicketCreation.vue?vue&type=script&lang=ts"
export * from "./TicketCreation.vue?vue&type=script&lang=ts"
import style0 from "./TicketCreation.vue?vue&type=style&index=0&id=60c4a3c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c4a3c9",
  null
  
)

export default component.exports